module.exports = __webpack_public_path__ + "3397303e8102fac5ab58de2bced46fd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/screens/Home/images/paso2.svg
// module id = 1465
// module chunks = 0